import * as types from "../types";

export const createQrScanLog = ({ userId, roomId, action, notes }) => ({
  type: types.CREATE_QR_SCAN_LOG,
  request: {
    url: "/qr_scan_logs",
    method: "POST",
    data: {
      qrScanLog: {
        userId,
        roomId,
        action,
        notes
      }
    }
  }
});

export const createBatchQrScanLog = ({ roomId, action }) => ({
  type: types.CREATE_BATCH_QR_SCAN_LOG,
  request: {
    url: "/qr_scan_logs/create_batch",
    method: "POST",
    data: {
      qrScanLog: {
        roomId,
        action
      }
    }
  }
});
